<div class="py-4 px-4 md:px-6 lg:pl-10 lg:pr-8 xl:pl-20 flex flex-col justify-center items-start gap-4 bg-white sticky top-0 z-50">
    <div class="text-[#222222] text-xl font-bold whitespace-nowrap">
        {{ 'tickets.tickets_title' | transloco }}
    </div>
    <div class="flex flex-col lg:flex-row justify-start items-center gap-2 w-full">
        <!--<mat-form-field
            appearance="outline"
            class="w-full lg:w-auto bg-white"
            color="accent"
            subscriptSizing="dynamic"
        >
            <mat-label>{{ "State" | transloco }}</mat-label>
            <mat-select [formControl]="stateFormControl">
                <ng-container>
                    <mat-option value="all">All</mat-option>
                    <mat-option value="in_progress">In Progress</mat-option>
                    <mat-option value="resolved">Resolved</mat-option>
                    <mat-option value="closed">Closed</mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>-->

        <!--<button class="w-full lg:w-auto" mat-stroked-button>
            {{ "Show unread" | transloco }}
        </button>-->

        <!-- <button (click)="startNewTicketConversation()" class="w-full lg:w-auto bg-[#F10051] bg-neut" color="primary" mat-flat-button>
            {{ "Open a ticket" | transloco }}
        </button> -->
    </div>
</div>

<div class="w-full py-4 px-4 md:px-6 lg:pl-10 lg:pr-8 xl:pl-20 flex-col justify-center items-start gap-4 inline-flex">
    <div *ngFor="let ticket of filteredTickets" class="self-stretch flex-col justify-center items-start gap-4 flex">
        <div (click)="selectTicket(ticket)"
             [ngClass]="{'bg-[#F7F7F7]': activeTicket && ticket.id === activeTicket.id}"
             class="relative self-stretch px-6 py-4 rounded-xl flex flex-col justify-start items-start gap-2.5 overflow-hidden"
        >

            <!-- Indicador de ticket no leído
            <ng-container *ngIf="!ticket.read">
                <div class="absolute top-3 right-3 w-2 h-2 bg-[#F10051] rounded-full"></div>
            </ng-container>-->

            <div class="self-stretch flex flex-col justify-start items-start gap-0.5">
                <div class="text-[#222222] font-semibold">
                    {{ ticket.title }}
                </div>
                <div class="w-full text-[#5e5e5e] truncate">
                    {{ ticket.description }}
                </div>
                <div class="mt-0.5 flex justify-start items-center gap-2">
                    <div class="text-[#5e5e5e] text-sm">
                        {{ ticket.created_at | date:'MMM dd, yyyy' }}
                    </div>
                    <div class="w-0.5 h-0.5 bg-[#5e5e5e] rounded-full"></div>
                    <div [ngClass]="{
                        'text-[#004CC4]': ticket.status === 'new_ticket',
                        'text-[#bf6a02]': ticket.status === 'in_progress',
                        'text-[#C00F0C]': ticket.status === 'closed',
                        'text-[#009951]': ticket.status === 'resolved'
                      }"
                         class="text-sm font-semibold"
                    >
                        {{
                            ticket.status === 'new_ticket'
                                ? ('tickets.new_ticket' | transloco)
                                : ticket.status === 'in_progress'
                                    ? ('tickets.in_progress' | transloco)
                                    : ticket.status === 'closed'
                                        ? ('tickets.closed' | transloco)
                                        : ticket.status === 'resolved'
                                            ? ('tickets.resolved' | transloco)
                                            : ticket.status
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
